export const AGENT_WORKSPACE_FEATURE_ENV = "REACT_APP_AGENT_WORKSPACE_BOUNDARY_A";
export const AGENT_WORKSPACE_ENABLED_VALUE = "enabled";
export const AGENT_WORKSPACE_ACCOUNT_ALLOWLIST_ENV = "REACT_APP_AGENT_WORKSPACE_ACCOUNT_ALLOWLIST";
export const AGENT_WORKSPACE_ROUTE = "/app/agent-workspace";
// P4-WP-9A.1: "/app" rather than "/app/warroom". A closed rollout gate must
// not deposit the caller on a module they may not hold -- Sales Agent has
// war_room="off" since WP-9A -- so the fallback defers to the canonical
// DefaultHomeRedirect resolver instead of naming a destination. The gate
// PREDICATE (isAgentWorkspaceEnabled) is deliberately unchanged.
export const AGENT_WORKSPACE_FALLBACK_ROUTE = "/app";

// Comma-separated production account allowlist. Trims whitespace and drops
// empty entries so "a, ,b," and " a,b " both yield ["a", "b"]. A missing,
// empty, or entirely-empty-after-trim value parses to [] -- callers must
// treat [] as fail-closed, never as "no restriction."
function parseAccountAllowlist(rawValue) {
  if (typeof rawValue !== "string") return [];
  return rawValue
    .split(",")
    .map((id) => id.trim())
    .filter((id) => id.length > 0);
}

export function evaluateAgentWorkspaceGate({
  configuredValue,
  environment,
  accountId,
  allowlistValue,
} = {}) {
  if (configuredValue !== AGENT_WORKSPACE_ENABLED_VALUE) return false;

  // Preserved development behavior: no account allowlist involved.
  if (environment === "development") return true;

  if (environment === "production") {
    const allowlist = parseAccountAllowlist(allowlistValue);
    if (allowlist.length === 0) return false;
    if (!accountId) return false;
    return allowlist.includes(accountId);
  }

  // Every other environment (test, staging, undefined, ...) fails closed.
  return false;
}

export function isAgentWorkspaceEnabled({ accountId } = {}) {
  return evaluateAgentWorkspaceGate({
    configuredValue: process.env[AGENT_WORKSPACE_FEATURE_ENV],
    environment: process.env.NODE_ENV,
    accountId,
    allowlistValue: process.env[AGENT_WORKSPACE_ACCOUNT_ALLOWLIST_ENV],
  });
}
